import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'VehicleGeneration',
		endpoint: '/vehicle/generation',
        items: [],
    },
    actions: {
		load (context, params) {
			return axios.get(`/vehicle/model/${params.model.id}/generation`).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}